import React from "react";
import { Button, Text } from "@nextui-org/react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import {
  TbArrowBackUp,
  TbFileExport,
  TbCheck,
  TbPlus,
  TbChartBar,
} from "react-icons/tb";

const AltLedgerHeader = ({ onExportAll, onExportEntries, onExportDeductions }) => {
  const navigate = useNavigate();

  return (
    <motion.div className="header">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Link to="/analytics" className="headerLink">
          <TbArrowBackUp className="icoAdjust" />
        </Link>
        <Text b>Ledger</Text>
      </div>
      <div className="headerLink headerLinkAddon" style={{ width: 280 }}>
        <Button
          auto
          size="sm"
          color="secondary"
          icon={<TbChartBar />}
          onClick={() => navigate("/analytics/alt-entries-analytics")}
          title="Analytics"
        />
        <Button
          auto
          size="sm"
          color="error"
          icon={<TbFileExport />}
          onClick={onExportAll}
          title="Export All"
        />
        <Button
          auto
          size="sm"
          color="warning"
          icon={<TbPlus />}
          onClick={onExportEntries}
          title="Export Entries"
        />
        <Button
          auto
          size="sm"
          color="success"
          icon={<TbCheck />}
          onClick={onExportDeductions}
          title="Export Deductions"
        />
      </div>
    </motion.div>
  );
};

export default AltLedgerHeader;
